import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/rings"
    exact
    path="/business/showcase/rings"
    component={AsyncPage}
  />,
];
